var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.403846 13.75C0.134615 13.5 0 13.125 0 12.875C0 12.625 0.134615 12.25 0.403846 12L2.28846 10.25C2.82692 9.75 3.63462 9.75 4.17308 10.25L4.30769 10.375L11.7115 17.75C11.9808 18 12.3846 18 12.6538 17.75L30.6923 0.375H30.8269C31.3654 -0.125 32.1731 -0.125 32.7115 0.375L34.5962 2.125C35.1346 2.625 35.1346 3.375 34.5962 3.875L13.0577 24.625C12.7885 24.875 12.5192 25 12.1154 25C11.7115 25 11.4423 24.875 11.1731 24.625L0.673077 14.125L0.403846 13.75Z",
    fill: "#5FB16D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.b697666ef7d6ead97848b0577fb048d1.svg";
export { ForwardRef as ReactComponent };